<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="100" inline>
        <FormItem label="设备SN号">
          <Input placeholder="请输入" v-model="table.search.ClientSN"></Input>
        </FormItem>
        <FormItem label="服务">
          <Select placeholder="请选择" v-model="table.search.DicCode" class="w-250" clearable> 
            <Option
              v-for="(item, index) in DicSelect"
              :value="item.dictionaryCode"
              :key="index"
              >{{ item.dictionaryValue }}
            </Option>
          </Select>
        </FormItem>
      </Form>
      <!--操作区域-->
      <div>
        <Button class="mr-3" type="success" @click="search">查询</Button>
        <Button class="mr-3" type="primary" @click="addModal = true">新增</Button>
        <!-- <Button class="mr-3" type="warning" @click="deleteBatch">批量删除</Button> -->
      </div>

    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
      @selectionChange="selectionChange"
    ></DataTable>

    <!--新增-->
    <Modal
      v-model="addModal"
      title="新增版本"
      :footer-hide="true"
      
      :closable="false"
      @on-visible-change="addModelChange"
    >
      <clientadd
        v-if="addModal"
        @close="addModal = false"
        @loadData="search"
      ></clientadd>
    </Modal>

    <!--更新-->
    <Modal
      v-model="editModal"
      title="编辑版本"
      :footer-hide="true"
      
      :closable="false"
    >
      <clientedit
        v-if="editModal"
        @close="editModal = false"
        @loadData="search"
        :currentData="currentData"
      ></clientedit>
    </Modal>

    <!--详情-->
    <Modal
      v-model="detailModal"
      title="版本详情"
      :footer-hide="true"
      
      :closable="false"
    >
      <clientdetail
        v-if="detailModal"
        @close="detailModal = false"
        :currentData="currentData"
      ></clientdetail>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import clientadd from "../clientVersion/add.vue";
import clientedit from "../clientVersion/edit.vue";
import clientdetail from "../clientVersion/detail.vue";

export default {
  components: { DataTable, clientadd, clientedit, clientdetail },
  data: function () {
    return {
      currentData: {},
      detailModal: false,
      addModal: false,
      editModal: false,
      DicSelect: [],
      selectedClientIds: [],
      selectionData: [],
      table: {
        columns: [
          //   {
          //     type: "selection",
          //     width: 60,
          //     align: "center",
          //   },
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          { title: "版本名称", key: "versionName" },
          { title: "版本号", key: "versionCode" },
          { title: "服务", key: "dicName" },
          { title: "SN", key: "clientSN", tooltip: true },
          { title: "更新时间", key: "updateTime", tooltip: true },
          {
            title: "强制更新",
            key: "forceUpdate",
            width: "80",
            render: (h, value) => {
              return h("div", value.row.forceUpdate ? "是" : "否");
            },
          },
          { title: "备注", key: "remark", tooltip: true },
          {
            title: "操作",
            width: "200px",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row);
                      },
                    },
                  },
                  "查看"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toEdit(params.row);
                      },
                    },
                  },
                  "编辑"
                ),

                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#FA6266',
                    },
                    on: {
                      click: () => {
                        this.deleteSingle(params.row.id);
                      },
                    },
                  },
                  "删除"
                ),
              ]);
            },
          },
        ],
        apiUrl: "clientVersion/getList",
        search: {
          // ClientSN: "",
          // ClientName: "",
          // ClientType: "",
        },
      },
    };
  },

  created: function () {
    this.$common.getDictionaryByCode("9001").then((data) => {
      this.DicSelect = data;
    });
  },
  activated(){
    this.search()
  },
  methods: {
    search: function () {
      this.$refs.dataTable.initload();
    },

    toDetail: function (data) {
      this.detailModal = true;
      this.currentData = JSON.parse(JSON.stringify(data));
    },

    toAdd: function () {
      this.$router.push({ path: "departmentAdd" });
    },

    toEdit: function (data) {
      this.editModal = true;
      this.currentData = JSON.parse(JSON.stringify(data));
    },

    //单个删除
    deleteSingle: function (id) {
      this.$Modal.confirm({
        title: "操作不可逆,是否继续？",
        mask: false,
        onOk: () => {
          this.$api.post(`/clientversion/delete?id=${id}`).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("删除成功");
              this.search();
            }
          });
        },
      });
    },

    //批量删除
    // deleteBatch() {
    //   if (this.selectionData.length < 1) {
    //     this.$Message.warning("请先勾选数据");
    //   } else {
    //     let ids = [];
    //     this.selectionData.forEach((item) => {
    //       ids.push(item.clientID);
    //     });
    //     let _ids = ids.join(";");
    //     this.$Modal.confirm({
    //       title: "会同步删除设备明细数据,是否继续？",
    //       mask: false,
    //       onOk: () => {
    //         this.$api.post(`/client/deleteBatch?ids=${_ids}`).then((rsp) => {
    //           if (rsp != false) {
    //             this.$Message.success("删除成功");
    //             this.search();
    //           }
    //         });
    //       },
    //     });
    //   }
    // },
    addModelChange(data) {
      if (
        data &&
        document.getElementsByClassName("ivu-upload-list").length > 0
      ) {
        document.getElementsByClassName("ivu-upload-list")[0].innerHTML = "";
      }
    },
    //多选回调
    selectionChange(data) {
      this.selectionData = data;
    },
  },
};
</script>
<style scoped>
</style>